import Error from './Error';

export { Props } from './Error';
export default Error;